import { FIELD_TYPES } from "constants/template-field-type";
export default {
    withPrivacyNotice: {
        type: FIELD_TYPES.BOOLEAN,
        label: "With Privacy Notice"
    },
    useNewBaseForm: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Use New Base Form",
        defaultValue: false
    },
    dontRenderPostFormSubmit: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Don't render post form submit (only for base form)",
        defaultValue: false
    }
};
